import script from "./floatnav.vue?vue&type=script&setup=true&lang=ts"
export * from "./floatnav.vue?vue&type=script&setup=true&lang=ts"

import "./floatnav.vue?vue&type=style&index=0&id=3c792b47&lang=less&scoped=true"

import exportComponent from "/Users/user/Projects/simweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c792b47"]])

export default __exports__